import React from 'react';

import ShowProgress from './show-progress';

import { pythonTaskApi } from '~/client/services';

interface SampleOutput {
  state: string;
  progress?: string;
  userId?: string;
  result?: unknown;
}

interface Props {}

const RunTask: React.FC<Props> = () => {
  const [startTask, result] = pythonTaskApi.useStartMutation();
  const [output, setOutput] = React.useState<SampleOutput>();

  const data = result.data;
  const taskId = data?.taskId;

  return (
    <div>
      <button
        onClick={() => {
          setOutput(undefined);
          startTask({
            some: 'additional-data',
          });
        }}
      >
        Start Python Task
      </button>
      <p />
      {!!data && (
        <>
          <div>Task Result</div>
          <pre>{JSON.stringify(data, null, 2)}</pre>
          <p />
        </>
      )}
      <p />
      {!!taskId && (
        <ShowProgress
          taskId={taskId}
          pollingInterval={2000}
          onComplete={setOutput}
        />
      )}
      {!!output && (
        <>
          <div>Final Result</div>
          <pre>{JSON.stringify(output, null, 2)}</pre>
        </>
      )}
    </div>
  );
};

export default RunTask;
